// @flow

export * from './ellastvmaxTheme'
export { default as ellastvmaxBrandConfig } from './brand_config.json'
